import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import MemberSidebar from "./MemberSidebar";
import MemberTopBar from "./MemberTopBar";
import useMediaQuery from "../shared/useMediaQuery";

const COLLAPSE_STORAGE_KEY = "rsc_member_sidebar_collapsed";
const TABLET_QUERY = "(max-width: 960px)";
const MOBILE_QUERY = "(max-width: 640px)";
const EXPANDED_WIDTH = 260;
const COLLAPSED_WIDTH = 84;
const TABLET_RAIL_WIDTH = 60;

export default function MemberLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(COLLAPSE_STORAGE_KEY) === "1";
  });
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const isTablet = useMediaQuery(TABLET_QUERY);
  const isMobile = useMediaQuery(MOBILE_QUERY);

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      window.localStorage.setItem(COLLAPSE_STORAGE_KEY, next ? "1" : "0");
      return next;
    });
  };

  const effectiveCollapsed = collapsed || isTablet;
  const railWidth = effectiveCollapsed ? (isTablet ? TABLET_RAIL_WIDTH : COLLAPSED_WIDTH) : EXPANDED_WIDTH;

  return (
    <div
      className="member-app tw-flex tw-h-screen tw-bg-background tw-overflow-hidden"
      style={{ display: "flex", height: "100vh", background: "#101010", overflow: "hidden" }}
    >
      {!isMobile && (
        <aside
          className="tw-flex tw-shrink-0"
          style={{
            width: railWidth,
            flexShrink: 0,
            transition: "width 0.28s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          <MemberSidebar collapsed={effectiveCollapsed} onToggleCollapse={isTablet ? undefined : toggleCollapsed} />
        </aside>
      )}

      {isMobile && mobileNavOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 60,
            display: "flex",
            background: "rgba(0,0,0,0.62)",
            backdropFilter: "blur(3px)",
          }}
          onClick={() => setMobileNavOpen(false)}
        >
          <aside
            style={{
              width: "min(84vw, 300px)",
              height: "100%",
              boxShadow: "20px 0 60px rgba(0,0,0,0.42)",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <MemberSidebar collapsed={false} onNavigate={() => setMobileNavOpen(false)} />
          </aside>
        </div>
      )}

      {/* Main content area */}
      <div
        className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0"
        style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}
      >
        <MemberTopBar onOpenSidebar={isMobile ? () => setMobileNavOpen(true) : undefined} />

        <main
          className="tw-flex-1 tw-overflow-y-auto tw-bg-background"
          style={{ flex: 1, overflowY: "auto", background: "#101010" }}
        >
          <div
            className="tw-max-w-[1200px] tw-w-full tw-mx-auto tw-px-4 md:tw-px-6 tw-py-5 tw-pb-20"
            style={{
              maxWidth: 1200,
              width: "100%",
              margin: "0 auto",
              padding: isMobile ? "16px 14px 72px" : isTablet ? "18px 18px 76px" : "20px 24px 80px",
              boxSizing: "border-box",
            }}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
